import { useTenantConfig } from '@packlink/tenant-config-provider';
import { Brand } from '@packlink/packlink-sdk';
import { WithCommonProps } from '@shipengine/giger';

import { EbayErrorPage } from './EbayErrorPage';
import { PaypalErrorPage } from './PaypalErrorPage';
import { ErrorPageTypes } from './ErrorPageTypes';

type ErrorPageProps = WithCommonProps<{
    type: ErrorPageTypes;
}>;

export function ErrorPage({ type, ...otherProps }: ErrorPageProps): JSX.Element | null {
    const { brand } = useTenantConfig<ITenantConfig>();
    const isPaypal = brand.toLowerCase() === Brand.PAYPAL.toLowerCase();

    return (
        <div className="app__content-container error-content" {...otherProps}>
            {isPaypal ? <PaypalErrorPage /> : <EbayErrorPage errorType={type} />}
        </div>
    );
}
